import React, { useContext, useEffect } from "react";
import { Toaster } from "sonner";
import Footer from "./src/components/Footer";
import Header from "./src/components/Header";
import ProtectedHeader from "./src/components/ProtectedHeader";
import ProtectedFooter from "./src/components/ProtectedFooter";
import { AuthContext, AuthProvider } from "./src/context/AuthContext";
import "./src/styles/global.css";
import browserHydrateFunction from "./src/utils/browser-hydrate-function";
import Loader from "./src/components/Loader";

export const replaceHydrateFunction = browserHydrateFunction;

export const onPreRouteUpdate = () => {
  document.body.classList.add("loading");
};

export const onRouteUpdate = () => {
  setTimeout(() => {
    document.body.classList.remove("loading");
  }, 500);
};

export const wrapRootElement = ({ element }) => {
  return (
    <AuthProvider>
      <AuthConsumerWrapper>{element}</AuthConsumerWrapper>
      <Toaster richColors />
    </AuthProvider>
  );
};

const AuthConsumerWrapper = ({ children }) => {
  const auth = useContext(AuthContext);
  const { isAuthenticated } = auth ?? { isAuthenticated: false }

  return (
    <>
      <Loader />
      {isAuthenticated ? <ProtectedHeader /> : <Header />}
      {children}
      {isAuthenticated ? <ProtectedFooter /> : <Footer />}
    </>
  );
};
